import { Activity, Calendar, Check, Star } from 'lucide-react';
import { useTranslations } from 'next-intl';

const ChangelogPreview = () => {
      const t = useTranslations('landing.changelog_preview');
      return (
            <div className="glass-card dark:bg-gray-800 rounded-xl overflow-hidden">
                  <div className="bg-kiwilog text-white p-4 flex items-center justify-between">
                        <h3 className="font-medium">{t('title')}</h3>
                        <button className="text-sm rounded-full bg-white/20 px-3 hover:bg-white/30 transition-colors">
                              {t('subscribe')}
                        </button>
                  </div>

                  <div className="p-5 max-h-[400px] overflow-y-auto">
                        {/* Update Entry 1 */}
                        <div className="mb-6 animate-slide-in">
                              <div className="flex items-center mb-2">
                                    <div className="bg-kiwilog/10 p-1.5 rounded-full text-kiwilog mr-3">
                                          <Star size={16} />
                                    </div>
                                    <h4 className="font-semibold">{t('new_feature_release')}</h4>
                                    <span className="flex gap-1 ml-auto text-xs text-gray-500 items-center">
                                          <Calendar className="size-3" />
                                          {t('today')}
                                    </span>
                              </div>
                              <p className="text-sm text-gray-700 dark:text-gray-300 pl-9">
                                    {t('introduced_dashboard_interface')}
                              </p>
                              <div className="pl-9 mt-2 flex flex-wrap gap-2">
                                    <span className="inline-block text-xs bg-purple-100 text-purple-800 px-2 py-0.5 rounded-full">
                                          {t('dashboard')}
                                    </span>
                                    <span className="inline-block text-xs bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full">
                                          {t('analytics')}
                                    </span>
                                    <span className="inline-block text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full">
                                          {t('new_feature')}
                                    </span>
                              </div>
                        </div>

                        {/* Update Entry 2 */}
                        <div className="mb-6 animate-slide-in animation-delay-100">
                              <div className="flex items-center mb-2">
                                    <div className="flex gap-2 bg-green-100 p-1.5 rounded-full text-green-600 mr-3">
                                          <Check size={16} />
                                    </div>
                                    <h4 className="font-semibold">{t('bug_fix')}</h4>
                                    <span className="flex gap-1 ml-auto text-xs text-gray-500 items-center">
                                          <Calendar className="size-4" />
                                          {t('yesterday')}
                                    </span>
                              </div>
                              <p className="text-sm text-gray-700 dark:text-gray-300 pl-9">
                                    {t('fixed_an_issue_where_exported_reports_would_sometimes_include_incorrect_date_ranges')}
                              </p>
                              <div className="pl-9 mt-2 flex flex-wrap gap-2">
                                    <span className="inline-block text-xs bg-red-100 text-red-800 px-2 py-0.5 rounded-full">
                                          {t('bug_fix')}
                                    </span>
                                    <span className="inline-block text-xs bg-amber-100 text-amber-800 px-2 py-0.5 rounded-full">
                                          {t('reporting')}
                                    </span>
                              </div>
                        </div>

                        {/* Update Entry 3 */}
                        <div className="animate-slide-in animation-delay-200">
                              <div className="flex items-center mb-2">
                                    <div className="bg-blue-100 p-1.5 rounded-full text-blue-600 mr-3">
                                          <Activity size={16} />
                                    </div>
                                    <h4 className="font-semibold">{t('performance_improvement')}</h4>
                                    <span className="flex gap-1 ml-auto text-xs text-gray-500 items-center">
                                          <Calendar className="size-4" />
                                          {t('3_days_ago')}
                                    </span>
                              </div>
                              <p className="text-sm text-gray-700 dark:text-gray-300 pl-9">
                                    {t('optimized_application_load_time_by_40_through_caching_improvements_and_asset_compression')}
                              </p>
                              <div className="pl-9 mt-2 flex flex-wrap gap-2">
                                    <span className="inline-block text-xs bg-indigo-100 text-indigo-800 px-2 py-0.5 rounded-full">
                                          {t('performance')}
                                    </span>
                                    <span className="inline-block text-xs bg-teal-100 text-teal-800 px-2 py-0.5 rounded-full">
                                          {t('optimization')}
                                    </span>
                              </div>
                        </div>
                  </div>
            </div>
      );
};

export default ChangelogPreview;